export const convertToLocalTime = (timestamp) => {
  if (!timestamp) return '';

  try {
    let date;

    // Handle server format: "2025-02-20 03:03:06 SA UTC"
    if (typeof timestamp === 'string' && timestamp.includes('UTC')) {
      // Parse the timestamp parts
      const parts = timestamp.split(' ');
      if (parts.length === 4) {
        const [datePart, timePart, meridiem] = parts;
        
        // Convert time based on SA/CH (morning/afternoon)
        let [hours, minutes, seconds] = timePart.split(':').map(Number);
        if ((meridiem === 'CH' || meridiem === 'PM') && hours < 12) {
          hours += 12;
        }
        if ((meridiem === 'SA' || meridiem === 'AM') && hours === 12) {
          hours = 0;
        }

        // Reconstruct UTC date string
        const utcString = `${datePart}T${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}Z`;
        date = new Date(utcString);
      } else {
        // Fallback if format doesn't match
        const cleanTimestamp = timestamp.replace(' SA UTC', '').replace(' CH UTC', '').replace(' AM UTC', '').replace(' PM UTC', '');;
        date = new Date(cleanTimestamp + 'Z');
      }
    } else {
      date = new Date(timestamp);
    }
    
    // Return empty string if invalid date
    if (isNaN(date.getTime())) {
      console.warn('Invalid date format:', timestamp);
      return '';
    }

    // // Log for debugging
    // console.log('Time conversion:', {
    //   original: timestamp,
    //   parsed: date.toISOString(),
    //   browserTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    //   localTime: date.toLocaleTimeString()
    // });

    // Convert to local time string
    return date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use 24-hour format
    });

  } catch (error) {
    console.error('Error converting time:', error);
    return '';
  }
};